var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPlayBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 31,
    height: 31,
    rx: 7,
    fill: "#25D4A9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0715 9.07141C11.2431 9.07141 10.5715 9.74298 10.5715 10.5714V20.4286C10.5715 21.257 11.2431 21.9286 12.0715 21.9286C12.9 21.9286 13.5715 21.257 13.5715 20.4286V10.5714C13.5715 9.74298 12.9 9.07141 12.0715 9.07141Z",
    fill: "#25D4A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9287 9.07141C18.1003 9.07141 17.4287 9.74298 17.4287 10.5714V20.4286C17.4287 21.257 18.1003 21.9286 18.9287 21.9286C19.7571 21.9286 20.4287 21.257 20.4287 20.4286V10.5714C20.4287 9.74298 19.7571 9.07141 18.9287 9.07141Z",
    fill: "#25D4A9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlayBg);
export default __webpack_public_path__ + "static/media/icon-play-bg.d9f19e33e7cdaf7c33a5b037d5cbf81d.svg";
export { ForwardRef as ReactComponent };